import _ from "lodash-es"
import { useMemo } from "react"

export function useReviewImages(reviews: any[]) {
  return useMemo(() => {
    return _.flatten(
      (reviews || []).map((review) => {
        return review?.images_data
          ? review.images_data.map((data: any) => ({
              alt: review.title,
              id: data.id,
              image: data.original_url,
              review: review.id,
              thumbnail: data.thumb_url,
            }))
          : []
      })
    ).filter(Boolean)
  }, [reviews])
}
